// src/store/useRegisterStore.ts
import { create } from "zustand";
import {
  registerCandidateApi,
  registerCompanyApi,
  confirmOtpApi,
  resendOtpApi,
} from "../api/registerApi";
import { toast } from "react-toastify";

interface RegisterState {
  loading: boolean;
  error: string | null;

  registerCandidate: (payload: any) => Promise<void>;
  registerCompany: (payload: any) => Promise<void>;
  confirmOtp: (payload: { email: string; otp: string }) => Promise<void>;
  resendOtp: (email: string) => Promise<void>;

  reset: () => void;
}

export const useRegisterStore = create<RegisterState>((set) => ({
  loading: false,
  error: null,

  registerCandidate: async (payload) => {
    try {
      set({ loading: true, error: null });
      await registerCandidateApi(payload);
      toast.success("Registration successful");
    } catch (err: any) {
      const message = err?.message || "Register candidate failed";
      set({ error: message });
      toast.error(message);
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  registerCompany: async (payload) => {
    try {
      set({ loading: true, error: null });
      await registerCompanyApi(payload);
      toast.success("Company registered successfully");
    } catch (err: any) {
      const message = err?.message || "Register company failed";
      set({ error: message });
      toast.error(message);
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  confirmOtp: async (payload) => {
    try {
      set({ loading: true, error: null });
      await confirmOtpApi(payload);
      toast.success("OTP verified successfully");
    } catch (err: any) {
      const message = err?.message || "OTP verification failed";
      set({ error: message });
      toast.error(message);
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  resendOtp: async (email) => {
    try {
      set({ loading: true, error: null });
      const res = await resendOtpApi(email);

      // 🔥 RESPONSE API KAMU
      // { "message": "New OTP sent successfully." }
      toast.success(res.message);
    } catch (err: any) {
      const message = err?.message || "Resend OTP failed";
      set({ error: message });
      toast.error(message);
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  reset: () => set({ loading: false, error: null }),
}));
